export const safeText = (value, fallback = "-") => {
  if (value === null || value === undefined || value === "") return fallback;
  if (Array.isArray(value)) return value.length ? value.join(", ") : fallback;
  if (typeof value === "object") return fallback;
  return String(value);
};

export const renderYesNo = (value) => {
  if (value === true || value === "true" || value === "Yes" || value === "yes") return "Yes";
  if (value === false || value === "false" || value === "No" || value === "no") return "No";
  return "-";
};

export const getNumberOrNA = (value) => (value === 0 ? "0" : safeText(value, "N/A"));

export const getObjectKeys = (obj) => {
  if (!obj || typeof obj !== "object") return [];
  return Object.keys(obj);
};

export const principleTitles = [
  "Businesses should conduct and govern themselves with integrity, and in a manner that is Ethical, Transparent and Accountable.",
  "Businesses should provide goods and services in a manner that is sustainable and safe.",
  "Businesses should respect and promote the well-being of all employees, including those in their value chains.",
  "Businesses should respect the interests of and be responsive to all its stakeholders.",
  "Businesses should respect and promote human rights.",
  "Businesses should respect and make efforts to protect and restore the environment.",
  "Businesses, when engaging in influencing public and regulatory policy, should do so in a manner that is responsible and transparent.",
  "Businesses should promote inclusive growth and equitable development.",
  "Businesses should engage with and provide value to their consumers in a responsible manner.",
];
